module.exports = __webpack_public_path__ + "static/media/27OCHA8.4901800b.jpg";